import { useEffect } from 'react'
import { TITLE_PREFIX } from '../constants/constants'

export function useDocumentTitle(title) {
    useEffect(() => {
        document.title = TITLE_PREFIX ? `${TITLE_PREFIX} | ${title}` : title
    }, [title])
}
